module.exports = __webpack_public_path__ + "img/help1.927271c8.jpg";